import { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootStateType } from "../../storeRedux/store";
import { useLangContext } from "../../context/Lang";
import { Link, useNavigate } from "react-router-dom";
import {motion} from "framer-motion";
import { DropdownMenu } from "../../components/Dropdown/Dropdown";
import { Button } from "components/Button/Button";
import { LayoutDashboardIcon, LogInIcon, LogOutIcon, UserIcon } from "lucide-react";
import { routes } from "routes";
import { ReplaceWords } from "utils/ReplaceWords";
import { AppIcon } from "components/AppIcon/AppIcon";
import { UserImage } from "components/UserImage/UserImage";






interface HeaderProps{

}


export const Header=({...props}:HeaderProps):ReactElement=>{

    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)
    const {auth}=useSelector((state:RootStateType)=>state);
    const {user}=auth;
    const {gW,LanguagesDrop}=useLangContext();
    const navigate= useNavigate();
    
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {

        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            setScrolled(isScrolled);
        };
    
        window.addEventListener("scroll", handleScroll);
        return () =>window.removeEventListener("scroll", handleScroll);
    }, []);
    

    return<>
    
        {/* <Sidebar
            side={props.sideDirection}
            onClick={()=>{ setIsSidebarOpen(false)}}
            icon={ props.image||icon}
            sideItems={props.sideItems}
            className=" bg-white "
            position="fixed"
            isSidebarOpen={  isSidebarOpen}
            setIsSidebarOpen={()=>setIsSidebarOpen(!isSidebarOpen)}
        /> */}
        <header className={" sticky top-0 z-[100000]    border-primary     text-white    duration-300 backdrop-blur-lg   "+(scrolled? ` bg-primary-100/40  border-b  `:" border-none ")  } >
            
            <motion.div 
                initial={{y:-100/90,opacity:0}} 
                animate={{y:0,opacity:1}} 
                transition={{duration:0.5}} 
                className={"flex p-2 px-4 scale-90 md:scale-100/90  relative z-[1000]  items-center m-auto h-full container duration-300 "}
            >

                

                <div className={"flex md:px-2 justify-between w-full duration-300   items-center"+(scrolled?" scale-[90%]  ":" scale-100/90 ") }>
                    <div className=" relative z-[10] flex items-center gap-2  ">
                        {<LanguagesDrop/>}

                        

                        {user?.id?<DropdownMenu
                            
                            items={[
                                {label:gW("dashboard") ,icon:<LayoutDashboardIcon size={15} />,onClick:()=>{navigate(routes.dashboard)} },
                                {label:gW("logout") ,icon:<LogOutIcon size={15} />,onClick:()=>{navigate(ReplaceWords(routes.authProcess,{pro:"logout"}))} }
                            ]}
                            trigger={<>
                                <UserImage/>
                                {user?.name}
                            </>}
                        />
                        :<></>
                        
                        // <Link to={ReplaceWords(routes.authProcess,{pro:"login"})} >
                        //     <Button  > 
                        //         <LogInIcon/> { gW("login")}
                        //     </Button>
                        // </Link>
                        }

                    </div>
                
                    <div className=" hidden  md:block ">
                        {/* <NavList
                            // color={ color}
                            {...props.navList}
                        /> */}
                    </div>
                    <div className=" flex  gap-3   " >
                        <Link to="/">
                            <motion.div 
                                initial={{x:-100,opacity:0}} 
                                animate={{x:0,opacity:1}} 
                                transition={{type:"spring",delay:1,duration:0.5}} 
                                className="text-2xl duration-300  cursor-pointer font-bold "
                            
                            > 
                                <AppIcon/>
                            </motion.div>
                        </Link>
                    </div>
                </div>
            </motion.div>
            
        </header>
    </> 
}